import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ml-30" }
const _hoisted_2 = { class: "mb-x2" }
const _hoisted_3 = { class: "block font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "block"
}
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "block" }

import {
    BasketAddress,
    BasketBuyer,
    PickAndPackCheckOutDeliverable,
    PickAndPackHomeDeliveryCheckOutDeliveryOption,
} from '@/storecontext/shared/api/server-apis';
import { computed, ComputedRef } from 'vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import useBooleanToggle from '@/shared/useBooleanToggle';
import CheckoutChangeAddress from '@/storecontext/checkout/ui/CheckoutChangeAddress.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackHomeDeliveryInfo',
  props: {
    deliverable: null,
    deliveryOption: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: PickAndPackCheckOutDeliverable;
    deliveryOption: PickAndPackHomeDeliveryCheckOutDeliveryOption;
}



const labels = useBlockLabels();
const { invoiceAddress } = useCheckout();
const { isToggled, toggle } = useBooleanToggle();

const deliveryAddress: ComputedRef<BasketAddress | undefined> = computed(() => {
    return props.deliveryOption.deliveryAddress?.address || invoiceAddress.value?.address;
});

const buyer: ComputedRef<BasketBuyer | undefined> = computed(() => {
    return props.deliveryOption.deliveryAddress?.buyer || invoiceAddress.value?.buyer;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).pickAndPackDeliveredToAddressTitle), 1),
      (_unref(buyer)?.companyName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(buyer)?.companyName), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(buyer)?.firstName) + " " + _toDisplayString(_unref(buyer)?.lastName), 1),
      _createElementVNode("span", _hoisted_6, [
        _createTextVNode(_toDisplayString(_unref(deliveryAddress)?.street), 1),
        (_unref(deliveryAddress)?.street2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(", " + _toDisplayString(_unref(deliveryAddress)?.street2), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(deliveryAddress)?.postalCode) + " " + _toDisplayString(_unref(deliveryAddress)?.city), 1),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(deliveryAddress)?.country), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "c-button c-button--outline",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)), ["prevent"]))
      }, _toDisplayString(_unref(labels).pickAndPackChangeAddressButton), 1)
    ]),
    _createVNode(CheckoutChangeAddress, {
      "deliverable-id": __props.deliverable.id,
      "delivery-address": __props.deliveryOption.deliveryAddress,
      "is-open": _unref(isToggled),
      onClose: _unref(toggle)
    }, null, 8, ["deliverable-id", "delivery-address", "is-open", "onClose"])
  ]))
}
}

})